"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPosition = void 0;
const ip_1 = __importDefault(require("ip"));
const os_1 = __importDefault(require("os"));
const types_1 = require("@refinitiv-data/types");
const detect_environment_1 = require("./detect-environment");
/**
 * Calculates position for the DACS object
 */
function getPosition() {
    if ((0, detect_environment_1.detectEnvironment)() === types_1.Environment.NODEJS) {
        return `${ip_1.default.address()}/${os_1.default.hostname()}`;
    }
    return 'browser';
}
exports.getPosition = getPosition;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0LXBvc2l0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3V0aWwvZ2V0LXBvc2l0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLDRDQUFvQjtBQUNwQiw0Q0FBb0I7QUFDcEIsaURBQW9EO0FBQ3BELDZEQUF5RDtBQUV6RDs7R0FFRztBQUNILFNBQWdCLFdBQVc7SUFDdkIsSUFBSSxJQUFBLHNDQUFpQixHQUFFLEtBQUssbUJBQVcsQ0FBQyxNQUFNLEVBQUUsQ0FBQztRQUM3QyxPQUFPLEdBQUcsWUFBRSxDQUFDLE9BQU8sRUFBRSxJQUFJLFlBQUUsQ0FBQyxRQUFRLEVBQUUsRUFBRSxDQUFDO0lBQzlDLENBQUM7SUFFRCxPQUFPLFNBQVMsQ0FBQztBQUNyQixDQUFDO0FBTkQsa0NBTUMifQ==